import { useTranslation } from 'react-i18next';

import { formatDate } from '@/utils/format';

interface DayDetailDatesCellProps {
  dates: string[];
}

/** Shows the first day in a multi-day row and how many more days share the plan. */
export const DayDetailDatesCell = ({ dates }: DayDetailDatesCellProps) => {
  const { t } = useTranslation('programs');

  const sorted = [...dates].filter(Boolean).sort((a, b) => a.localeCompare(b));
  if (sorted.length === 0) return '—';

  const first = sorted[0]!;
  const remaining = sorted.length - 1;

  return (
    <div className="space-y-0.5">
      <span className="whitespace-nowrap">{formatDate(first)}</span>
      {remaining > 0 ? (
        <p className="text-caption text-fg-secondary">
          {t('dayDetails.moreDates', { count: remaining })}
        </p>
      ) : null}
    </div>
  );
};

interface DayDetailReadingsCellProps {
  readings: string[];
}

/** Shows the first Bible reading and how many more share the plan. */
export const DayDetailReadingsCell = ({ readings }: DayDetailReadingsCellProps) => {
  const { t } = useTranslation('programs');

  if (readings.length === 0) return '—';

  const first = readings[0]!;
  const remaining = readings.length - 1;

  return (
    <div className="space-y-0.5">
      <span className="text-body-sm">{first}</span>
      {remaining > 0 ? (
        <p className="text-caption text-fg-secondary">
          {t('dayDetails.moreDates', { count: remaining })}
        </p>
      ) : null}
    </div>
  );
};
